import React from 'react';
import Row from "@amzn/meridian/esm/components/row";
import Column from "@amzn/meridian/esm/components/column";
import FeedbackCard from "../../common/FeedbackCard";
import { FEEDBACK_PAGE } from "../../common/constants";
import WikiCard from "../../common/WikiCard";
import PolicyCard from '../../common/PolicyCard';

/**
 * HelpTabInClient Component
 *
 * Displays the help tab content for the client interface, including FeedbackCard, WikiCard and PolicyCard
 * in a structured layout with specific spacing and alignment.
 *
 * @returns {JSX.Element} Help tab content with feedback and wiki cards for the client interface
 */
const HelpTabInClient = () => {
    return (
        <Column spacing="none">
            <Row spacingInset="none" spacing="none">
                <Row width="74px" />
                <Row width="272px">
                    <Column 
                        spacing="none" 
                        heights={["Pixels", "Pixels", "fit%"]} 
                        spacingInset="none" 
                        alignment="top" 
                        alignmentHorizontal="start"
                    >
                        <Column height="72px" />
                        <Column height="96px">
                            <FeedbackCard page={FEEDBACK_PAGE.IN_CLIENT_FEEDBACK_TAB} />
                        </Column>
                        <Column height="24px" />
                    </Column>
                </Row>
                <Row width="24px" />
                <Row width="272px">
                    <Column 
                        spacing="none" 
                        heights={["Pixels", "Pixels", "fit%"]} 
                        spacingInset="none" 
                        alignment="top" 
                        alignmentHorizontal="start"
                    >
                        <Column height="72px" />
                        <Column height="96px">
                            <WikiCard />
                        </Column>
                        <Column height="24px" />
                    </Column>
                </Row>
            </Row>
            <Row spacingInset="none" spacing="none" height="54px">
                <Row width="74px" />
                <Row width="272px">
                    <Column 
                        spacing="none" 
                        heights={["Pixels", "Pixels", "fit%"]} 
                        spacingInset="none" 
                        alignment="top" 
                        alignmentHorizontal="start"
                    >
                        <Column height="72px" />
                        <Column height="96px">
                            <PolicyCard />
                        </Column>
                        <Column height="24px" />
                    </Column>
                </Row>
            </Row>
        </Column>
    );
};

export default HelpTabInClient;
